import { render } from "./AboutPage.vue?vue&type=template&id=4787b20e"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=4787b20e&lang=css"
script.render = render

export default script